module.exports = __webpack_public_path__ + "img/diana-1-webp-512.fa832d39.webp";